import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import unclaimedPackageService from '../../services/unclaimedPackageService';

// Customer-facing only — packages an admin has possibleCustomer-tagged to
// the logged-in customer (see unclaimedPackageController.getMyUnclaimedPackages).
// Shared between the sidebar badge, the dashboard alert, and the dedicated
// page so all three stay in sync off one fetch instead of three.
export const fetchMyUnclaimedPackages = createAsyncThunk(
  'unclaimedPackages/fetchMine',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await unclaimedPackageService.getMine();
      return data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

const unclaimedPackagesSlice = createSlice({
  name: 'unclaimedPackages',
  initialState: {
    list: [],
    count: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyUnclaimedPackages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyUnclaimedPackages.fulfilled, (state, action) => {
        state.list = action.payload.packages;
        state.count = action.payload.count;
        state.loading = false;
      })
      .addCase(fetchMyUnclaimedPackages.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const selectMyUnclaimedPackages = (state) => state.unclaimedPackages.list;
export const selectMyUnclaimedPackagesCount = (state) => state.unclaimedPackages.count;
export default unclaimedPackagesSlice.reducer;
